import React from 'react';
import { withStyles, Tabs, Tab } from '@material-ui/core';
import styles from '../styles';
import StyledToolTip from '../../../../../common/StyledToolTip';
import { SaveAltSharp, AddRounded, DeleteOutline } from '@material-ui/icons';
import SearchBox from '../../../../../common/SearchBox';
import { csvFormulaInjectionSanitizer } from '../../../../../../utilities/csvUtils';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const HoldProHeader = ({
  classes,
  handleTabChange,
  tabId,
  gridApi,
  searchText,
  setSearchText,
  isAddFormOpen,
  setIsAddFormOpen,
  selectedData,
  onDeleteData,
  tabNames
}) => {
  const tabClasses = { root: classes.tabRoot, selected: classes.tabSelected };
  const disableDeleteIcon = selectedData.length <= 0;
  const disableAddIcon = isAddFormOpen;
  const exportCSV = () => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi.getColumns();
    const columnKeys = columns
      .filter((column) => !column.colDef.hide)
      .map((column) => column.getColId());
    const params = {
      fileName: tabNames[tabId],
      columnKeys,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    gridApi.exportDataAsCsv(params);
  };

  return (
    <div className={classes.headerStyle} key={tabId}>
      <span>
        <Tabs
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabsIndicator
          }}
          value={tabId}
          onChange={handleTabChange}>
          {tabNames.map((tabName, index) => (
            <Tab key={index} classes={tabClasses} disableRipple label={tabName} />
          ))}
        </Tabs>
      </span>
      <div className={classes.iconContainer}>
        <span
          onClick={exportCSV}
          className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}>
          <StyledToolTip title="Export Data">
            <SaveAltSharp />
          </StyledToolTip>
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout} ${
            disableDeleteIcon ? classes.disableIcon : classes.enableIcon
          }`}>
          <StyledToolTip
            title={disableDeleteIcon ? 'Select at least one row to delete' : 'Click to delete'}
            onClick={() => (!disableDeleteIcon ? onDeleteData(selectedData) : null)}>
            <DeleteOutline />
          </StyledToolTip>
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout} ${
            disableAddIcon ? classes.disableIcon : classes.enableIcon
          }`}>
          <StyledToolTip
            title={disableAddIcon ? 'Disable' : 'Create'}
            onClick={() => (!disableAddIcon ? setIsAddFormOpen(true) : null)}>
            <AddRounded />
          </StyledToolTip>
        </span>
        <span className={classes.gridActionIcons}>
          <SearchBox key={tabId} onChange={setSearchText} inputText={searchText} />
        </span>
        <span>
          <ClearAllFilterButton gridApi={gridApi} />
        </span>
      </div>
    </div>
  );
};

export default withStyles(styles)(HoldProHeader);
